import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import content from "@/content";

export const scrollToSection = (target) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -92 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, target) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(target);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-linen/85 backdrop-blur-md border-b border-ink/10 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand-link"
          onClick={(e) => go(e, "#hero")}
          className="font-serif text-xl tracking-[0.15em] uppercase text-black"
        >
          {content.brand.name}
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {content.nav.map((item, i) => (
            <a
              key={item.target}
              href={item.target}
              data-testid={`nav-link-${i}`}
              onClick={(e) => go(e, item.target)}
              className="text-[11px] uppercase tracking-[0.22em] text-slate2 hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#enquire"
            data-testid="nav-enquire-btn"
            onClick={(e) => go(e, "#enquire")}
            className="text-[11px] uppercase tracking-[0.22em] border border-ink/30 px-5 py-2.5 hover:bg-ink hover:text-linen hover:border-ink transition-colors duration-300"
          >
            Enquire
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-linen/95 backdrop-blur-md border-b border-ink/10 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {[...content.nav, { label: "Enquire", target: "#enquire" }].map((item, i) => (
                <a
                  key={item.target}
                  href={item.target}
                  data-testid={`nav-mobile-link-${i}`}
                  onClick={(e) => go(e, item.target)}
                  className="font-serif text-2xl"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
